import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';

export function digitalLiveClassResponse(response) {
  return {
    type: types.DIGITAL_LIVE_CLASS_RESPONSE,
    response
  };
}

export const digitalLiveClassRequest = async (params, isTeacher, dispatch) => {
  const jwtToken = params;
  const body = {};
  const url = isTeacher ? 'api/liveclasslist' : 'api/dc/student/livelist';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true) && !isTeacher) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(digitalLiveClassResponse(data));
    });
};

export function liveClassPlayerResponse(response) {
  return {
    type: types.LIVE_CLASS_PLAYER_RESPONSE,
    response
  };
}
export const liveClassPlayerRequest = async (
  loginData,
  isTeacher,
  uniqueCode,
  dispatch
) => {
  const jwtToken = loginData;
  const body = {
    UniqueCode: uniqueCode
  };
  const url = isTeacher ? 'api/liveclassplayer' : 'api/dc/student/liveplayer';
  return await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true) && !isTeacher) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning'
          })
        );
        return dispatch(logOut());
      }
      dispatch(liveClassPlayerResponse(data));
      return data;
    });
};
